import React from "react";

// Simple SVG avatar options
const AVATARS = [
  {
    name: "Avatar 1",
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="24" fill="#2563eb" />
        <circle cx="24" cy="20" r="10" fill="#fff" />
        <ellipse cx="24" cy="36" rx="12" ry="7" fill="#fff" />
      </svg>
    ),
    
    dataUrl:
      "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'><circle cx='24' cy='24' r='24' fill='%232563eb'/><circle cx='24' cy='20' r='10' fill='white'/><ellipse cx='24' cy='36' rx='12' ry='7' fill='white'/></svg>"
  },
  {
    name: "Avatar 2",
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="24" fill="#f59e0b" />
        <rect x="14" y="14" width="20" height="20" rx="10" fill="#fff" />
        <ellipse cx="24" cy="36" rx="10" ry="6" fill="#fff" />
      </svg>
    ),
    dataUrl:
      "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'><circle cx='24' cy='24' r='24' fill='%23f59e0b'/><rect x='14' y='14' width='20' height='20' rx='10' fill='white'/><ellipse cx='24' cy='36' rx='10' ry='6' fill='white'/></svg>"
  },
  {
    name: "Avatar 3",
    svg: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="24" fill="#10b981" />
        <ellipse cx="24" cy="20" rx="10" ry="12" fill="#fff" />
        <ellipse cx="24" cy="36" rx="12" ry="7" fill="#fff" />
      </svg>
    ),
    dataUrl:
      "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='48' height='48'><circle cx='24' cy='24' r='24' fill='%2310b981'/><ellipse cx='24' cy='20' rx='10' ry='12' fill='white'/><ellipse cx='24' cy='36' rx='12' ry='7' fill='white'/></svg>"
  }
];

export default function AvatarPicker({ onPick, selected }) {
  return (
    <div style={{ display: "flex", gap: 16, marginTop: 8, marginBottom: 8 }}>
      {AVATARS.map((avatar, idx) => (
        <button
          key={avatar.name}
          type="button"
          style={{
            border: selected === avatar.dataUrl ? "2px solid #2563eb" : "2px solid #e5e7eb",
            borderRadius: 8,
            background: "#fff",
            padding: 4,
            cursor: "pointer"
          }}
          aria-label={avatar.name}
          onClick={() => onPick(avatar.dataUrl)}
        >
          {avatar.svg}
        </button>
      ))}
    </div>
  );
}
